import { assocPath, isNil, path } from 'ramda';
import { IOfferState } from '../../types/reducers/offer';
import { TDynamicPricingAttributes } from '../../types/dynamicPricing';

interface IParams {
  offer: IOfferState | null;
  dynamicPricingAttributes: TDynamicPricingAttributes;
}

export const mapDynamicPricing = (params: IParams) => {
  const { offer, dynamicPricingAttributes } = params;

  return dynamicPricingAttributes.reduce((stash, key) => {
    const pathArray = key.split('.');
    const value = path(pathArray, offer);

    if (isNil(value)) {
      return stash;
    } else {
      return assocPath(pathArray, value, stash);
    }
  }, {});
};
